import React from 'react';

import {
  EmailShareButton,
  FacebookShareButton,
  RedditShareButton,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "react-share";

import {
  EmailIcon,
  FacebookIcon,
  RedditIcon,
  TelegramIcon,
  TwitterIcon,
  WhatsappIcon,
} from "react-share";

const SocialShareBar = (props) => {
    const buttonSize = 32;
  const onwardflightticket_url = "https://onwardflightticket.com";

  // Share Buttons contents
  const msg = "Create a personalized fake flight ticket on:";
  const email_subject = "Dummy flight ticket";
  const email_body = "Create a dummy ticket with real flight information on:";

  return (
  <div>
    <div className="d-flex justify-content-center align-items-center gap-2 flex-wrap mb-2">
      <WhatsappShareButton
        title={msg}
        url={onwardflightticket_url}
      >
        <WhatsappIcon size={buttonSize} round />
      </WhatsappShareButton>

      <FacebookShareButton
        quote={msg}
        url={onwardflightticket_url}
      >
        <FacebookIcon size={buttonSize} round />
      </FacebookShareButton>

      <TelegramShareButton
        url={onwardflightticket_url}
      >
        <TelegramIcon size={buttonSize} round />
      </TelegramShareButton>

      <TwitterShareButton
        title={msg}
        url={onwardflightticket_url}
      >
        <TwitterIcon size={buttonSize} round />
      </TwitterShareButton>

      <RedditShareButton
        title={msg}
        url={onwardflightticket_url}
      >
        <RedditIcon size={buttonSize} round />
      </RedditShareButton>

      <EmailShareButton
        subject={email_subject}
        body={email_body}
        url={onwardflightticket_url}
        hashtags={['keplergl']}
      >
        <EmailIcon size={buttonSize} round />
      </EmailShareButton>
    </div>
    <p className="text-center mb-0"><strong>Let your friends know about us :)</strong></p>
  </div>
  );
}

export default SocialShareBar;
